import { Button } from '@cimplico/components';
import { useEffect, useState } from 'react';
import { FYIUser } from '../../../types/fyi-docs';
import { Invitation } from '../../../types/invitation';
import { UserRoleEnum } from '../../../types/user';
import NewUserForm, { NewUserRowConfig } from '../NewUserForm';
import NewUserRow from '../NewUserRow';
import FYIUserSelect from './FYIUserSelect';

function NewFYIUsersForm(): JSX.Element {
    const [invites, setInvites] = useState<NewUserRowConfig[]>([]);

    function removeRow(id: string): void {
        setInvites((prev) => [...prev.filter((p) => p.id.toString() !== id)]);
    }

    function handleSelect(users: FYIUser[]): void {
        setInvites(
            users.map((u) => {
                return {
                    email: u.email,
                    id: u.id.toString(),
                    role: u.role === 'Admin' ? UserRoleEnum.MANAGER : UserRoleEnum.USER,
                };
            })
        );
    }
    if (invites.length === 0) {
        return <FYIUserSelect onSelect={handleSelect} />;
    }

    return <NewUserForm showImportSelect={false} invites={invites} />;
}
export default NewFYIUsersForm;
